import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../store/ui-slice";
import CartItem from "./CartItem";
import { useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getAmountUntilFreeShipping } from "../../utils/shipping";
import useShippingSettings from "../../hooks/useShippingSettings";

const ShoppingCart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isShow = useSelector((state) => state.ui.isShow);
  const cartItems = useSelector((state) => state.cart.cartItems);
  const subtotal = useSelector((state) => state.cart.subtotal);
  const totalQuantity = useSelector((state) => state.cart.totalQuantity);
  const { freeShippingThreshold } = useShippingSettings();
  const amountUntilFreeShipping = getAmountUntilFreeShipping(
    subtotal,
    freeShippingThreshold
  );
  const closeModal = () => {
    dispatch(uiActions.closeModal());
  };

  useEffect(() => {
    dispatch(uiActions.closeModal());
  }, [location.pathname, dispatch]);

  const shoppingCartItems = cartItems?.map((item) => {
    return (
      <CartItem
        key={item.id}
        item={{
          id: item.id,
          imgs: item.imgs,
          title: item.title,
          quantity: item.quantity,
          totalPrice: item.totalPrice,
          stockQuantity: item.stockQuantity,
        }}
      />
    );
  });
  return (
    <>
      <div
        className={`fixed left-0 top-0 z-[3] h-full w-full bg-black/40 transition duration-300 ${
          !isShow ? "hidden" : ""
        }`}
        onClick={closeModal}
      ></div>
      <div
        className={`fixed right-0 top-0 z-[4] flex h-screen w-full flex-col bg-white font-Heebo transition duration-300 min-[570px]:w-[370px] lg:w-[410px] ${
          !isShow ? "translate-x-full" : "translate-x-0"
        }`}
      >
        <div className="flex items-center justify-between border-b p-6 pb-4">
          <h6 className="font-bold">
            Your Shopping Cart (<span>{totalQuantity}</span>)
          </h6>
          <button
            type="button"
            className="flex h-9 w-9 items-center justify-center rounded-full text-gray-500 transition hover:bg-black/5 hover:text-black"
            onClick={closeModal}
            aria-label="Close cart"
          >
            <FontAwesomeIcon icon={faXmark} className="text-xl" />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6">
          {cartItems?.length === 0 ? (
            <div className="flex h-full flex-col items-center justify-center text-center">
              <div className="mx-auto h-24 w-24">
                <img className="h-full w-full" src="/images/empty.png" alt="" />
              </div>
              <h5 className="mb-3 mt-6 text-xl">Your cart is empty.</h5>
              <Link
                className="rounded-lg border border-black/20 bg-white px-5 py-2.5 text-center text-sm font-semibold transition hover:border-black hover:bg-lightBlack hover:text-white"
                to="/"
              >
                Keep browsing
              </Link>
            </div>
          ) : (
            shoppingCartItems
          )}
        </div>

        {cartItems?.length !== 0 && (
          <div className="flex items-center justify-between border-t bg-white p-6 font-bold">
            <div>
              <p className="mb-1 text-base min-[570px]:text-lg">Subtotal:</p>
              <p className="mb-1 text-base min-[570px]:text-lg">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency: "USD",
                }).format(subtotal)}
              </p>
              {amountUntilFreeShipping > 0 && (
                <p className="text-xs font-normal text-slate-500">
                  Add{" "}
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                  }).format(amountUntilFreeShipping)}{" "}
                  for free delivery over ${freeShippingThreshold}
                </p>
              )}
            </div>
            <button
              type="button"
              onClick={() => navigate("/checkout")}
              className="rounded-lg bg-lightBlack px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-black"
            >
              Checkout
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default ShoppingCart;
